import { createSlice } from '@reduxjs/toolkit';
import {
  IMsgForListAndRegistry,
  ShoppingCartData,
} from './ShoppingCart.interface';

interface ShopingCartInitState {
  ShoppingCartData: ShoppingCartData | {};
  msgForListAndRegistry: IMsgForListAndRegistry | {};
}

const ShopingCartState = {
  //ShoppingCart
  ShoppingCartData: {},
  msgForListAndRegistry: {},
} satisfies ShopingCartInitState as ShopingCartInitState;

export const ShoppingCartSlice = createSlice({
  name: 'cart',
  initialState: ShopingCartState,
  reducers: {
    setShoppingCartData(state, action) {
      const payload = action.payload || {};
      if (!payload.unavailableLines) {
        payload.unavailableLines = [];
      }
      if (payload?.header?.loyaltyInfo && payload?.rewardsInfo?.totalPoints) {
        payload.header.loyaltyInfo.totalPoints =
          payload.rewardsInfo.totalPoints;
      }
      console.log('ShoppingCartSlice', payload);
      state.ShoppingCartData = payload;
    },
    setMsgForListAndRegistry(state, action) {
      state.msgForListAndRegistry = action.payload;
    },
  },
});

export const { setShoppingCartData, setMsgForListAndRegistry } =
  ShoppingCartSlice.actions;

export default ShoppingCartSlice.reducer;
